import React from 'react';

function Footer() {
  return (
    <footer className="bg-primary">
      <div className="content py-8">
        <div className="text-white">
          <p>
            Copyright Purple Academy&nbsp;
            {new Date().getFullYear()}
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
